import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import etfHoldingService from '@etfHoldingService';

export function useFetchETFHoldings() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['etf_holdings', user?.id],
    queryFn: async () => {
      return await etfHoldingService.fetchEtfHoldings(user.id);
    },
    enabled: !!user,
  });
}

export function useCreateETFHolding() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (holding: Omit<ETFHoldingCreateRequest, "userId">) => {
      return await etfHoldingService.createEtfHolding({...holding, userId: user.id});
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['etf_holdings'] }),
  });
}

export function useUpdateETFHolding() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (req: Omit<ETFHoldingUpdateRequest, 'userId'>) => {
      return await etfHoldingService.updateEtfHolding({...req, userId: user.id})
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['etf_holdings'] }),
  });
}

export function useDeleteETFHolding() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (id: string) => {
      return await etfHoldingService.deleteEtfHolding({ id, userId: user.id })
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['etf_holdings'] }),
  });
}
